export default {
  'customList.title': 'Gestionar Listas',
  'customList.select.list': 'Lista',
  'customList.select.gantt': 'Gantt',
  'customList.select.calendar': 'Calendario',
  'customList.select.tasklist': 'Listado de Tareas',
  'customList.select.taskBoard': 'Tablero de Tareas',
  'customList.select.cardsList': 'Tarjetas',
  'customList.select.mapList': 'Mapa',
  'customList.select.and': 'AND',
  'customList.select.or': 'OR',
  'customList.form.preFiltersLogicalOperator': 'Operador Lógico Filtros Iniciales',
  'customList.form.permissionsFiltersLogicalOperator': 'Operador Lógico Permisos',
  'customList.form.isPublic': '¿Público?',

  'customList.setup.fields': 'Campos',
  'customList.setup.fields.displayText': 'Texto a Mostrar',
  'customList.setup.fields.type': 'Tipo',
  'customList.setup.fields.isFilterEnabled': '¿Filtro Habilitado?',
  'customList.setup.fields.form': 'Formulario',
  'customList.setup.fields.field': 'Campo',
  'customList.setup.fields.order': 'Orden',
  'customList.setup.fields.fieldBehavior': 'Comportamiento',
  'customList.setup.fields.logicalOperator': 'Operador Lógico',
  'customList.setup.fields.variable': 'Variable',
  'customList.setup.fields.isDefaultSortingColumn': '¿Campo Predeterminado Para Ordenar?',

  'customList.setup.fields.processName': 'Nombre Proceso',
  'customList.setup.fields.processGroupName': 'Nombre Grupo de Proceso',
  'customList.setup.fields.instanceName': 'Nombre Solicitud  ',
  'customList.setup.fields.instanceCreated': ' Fecha de Creación de Solicitud',
  'customList.setup.fields.instanceStatus': 'Estado de Solicitud',
  'customList.setup.fields.applicantFullName': 'Solicitante Nombre Completo',
  'customList.setup.fields.approvedDate': 'Fecha de Aprobación',
  'customList.setup.fields.rejectedDate': ' Fecha de Rechazo',
  'customList.setup.fields.applicantNames': 'Solicitante - Nombres',
  'customList.setup.fields.applicantLastNames': 'Solicitante - Apellidos',
  'customList.setup.fields.applicantEmail': 'Solicitante - Correo',
  'customList.setup.fields.applicantPosition': 'Solicitante Puesto',
  'customList.setup.fields.instanceIdentifier': 'Identificador Solicitud',

  'customList.setup.commands': 'Comandos',
  'customList.setup.commands.command': 'Comando',
  'customList.setup.commands.createRequest': 'Crear Solicitud',
  'customList.setup.commands.viewDetails': 'Ver Detalles',
  'customList.setup.commands.cancelRequest': 'Cancelar Solicitud',
  'customList.setup.commands.completeRequestInformation': 'Completar Información',
  'customList.setup.commands.approveRequest': 'Aprobar Solicitud',
  'customList.setup.commands.executeTask': 'Ejecutar Tarea',
  'customList.setup.commands.signDocument': 'Firmar Documento',
  'customList.setup.commands.reassignTask': 'Reasignar Tarea',
  'customList.setup.commands.massRequestsApprove': 'Aprobación Masiva de Solicitudes',
  'customList.setup.commands.export': 'Exportar',
  'customList.setup.commands.massRequestsReject': 'Rechazo Masivo de Solicitudes',

  'customList.setup.preFilters': 'Filtros Iniciales',

  'customList.setup.preFilters.preFilterType': 'Tipo de Filtro',
  'customList.setup.preFilters.filterValue': 'Valor Filtro',
  'customList.setup.preFilters.formFieldValueSource': 'Origen Valor Campo',
  'customList.setup.preFilters.fieldValue': 'Valor a Mostrar',
  'customList.setup.preFilters.fieldSearchValue': 'Valor de Búsqueda',
  'customList.setup.preFilters.variable': 'Variable',

  'customList.setup.preFilters.currentUserRequests': 'Solicitudes del Usuario Actual',
  'customList.setup.preFilters.instanceStatus': 'Estado Solicitud',
  'customList.setup.preFilters.formFieldValue': 'Valor Campo de Formulario',
  'customList.setup.preFilters.currentUserPendingRequests':
    'Solicitudes Pendientes del Usuario Actual',
  'customList.setup.preFilters.currentUserPendingCompleteInformationRequests':
    'Solicitudes Pendientes de Completar Información del Usuario Actual',
  'customList.setup.preFilters.currentUserPendingApprovalsRequests':
    'Solicitudes Pendientes de Aprobación del Usuario Actual',
  'customList.setup.preFilters.currentUserPendingExecuteTasksRequests':
    'Solicitudes Pendientes de Ejecución de Tarea del Usuario Actual',
  'customList.setup.preFilters.currentUserPendingSignRequests':
    'Solicitudes Pendientes de Firma del Usuario Actual',
  'customList.setup.preFilters.currentUserInteractionsRequests':
    'Solicitudes con Interacciones del Usuario Actual',
  'customList.setup.preFilters.variableValue': 'Valor Variable',
};
